import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { AuthService } from '@auth0/auth0-angular'
import { AuthConfigStorage } from '@cwan/ciam-angular'
import { paths } from '../paths'

@Component({
  selector: 'hs-login-error',
  templateUrl: './login-error.component.html',
  styleUrls: ['./login-error.component.scss'],
})
export class LoginErrorComponent {
  readonly homepage = paths.base

  constructor(
    private readonly authConfigStorage: AuthConfigStorage,
    private readonly auth0: AuthService,
    private readonly router: Router,
  ) {
    this.auth0.error$.subscribe(error => {})
  }

  clearStorage() {
    this.authConfigStorage.clear()
  }
}
